import { twMerge } from 'tailwind-merge';

const BaseAutocomplete = (props) => {
    const {
        id,
        name,
        label,
        labelClassName,
        errors,
        className,
        inputClassName,
        disabled = false,
        placeholder,
        value,
        setValue,
        onSelect,
        items,
        canAdd = false,
        onAddNew,
        isLoading,
        exclude,
        addText
    } = props;

    const errorClassname = errors?.length ? 'border-theme1-error' : '';

    const processedItems = items.length > 0 ? items.filter((item) => !exclude.includes(item.value)) : [];

    return (
        <div className={twMerge('w-full relative', className)}>
            <div className={twMerge('text-theme1-primary2 font-bold text-base mb-1', labelClassName)}>{label}</div>

            <input
                id={id ?? name}
                name={name}
                type='text'
                value={value}
                onChange={(e) => {
                    if (setValue) {
                        setValue(e.target.value);
                    }
                }}
                disabled={disabled}
                className={twMerge(
                    'text-theme1-text1 rounded-2xl border px-4 py-2 border-theme1-text3 w-full outline-none',
                    errorClassname,
                    inputClassName
                )}
                placeholder={placeholder ?? label}
            />
            {!isLoading && (processedItems.length > 0 || value !== '') && (
                <div className='absolute left-0 w-72 top-11 border border-theme1-border1 bg-theme1-white z-20 py-2 px-4 rounded-lg'>
                    {processedItems.length > 0 &&
                        processedItems.map((item) => {
                            if (!exclude.includes(item.value)) {
                                return (
                                    <div
                                        key={item.value}
                                        onClick={() => onSelect(item.value, item.label)}
                                        className='mb-2'
                                    >
                                        {item.label}
                                    </div>
                                );
                            }
                        })}
                    {processedItems.length === 0 && <div className='text-theme1-text3 text-sm'>Nothing found</div>}
                    {canAdd && (
                        <div onClick={onAddNew} className='text-theme1-text2 mt-1'>
                            {addText}
                        </div>
                    )}
                </div>
            )}

            {errors &&
                errors.map((error) => {
                    return (
                        <div key={error} className='mt-2.5 text-theme1-error'>
                            {error}
                        </div>
                    );
                })}
        </div>
    );
};

export default BaseAutocomplete;
